<template>
  <div>
    <div class="record1"></div>
    <div class="record3">
      <el-table v-loading='loading' stripe border :data="list" tooltip-effect="dark" style="width: 98%">
        <el-table-column align='center' prop="title" label="通知标题"></el-table-column>
        <el-table-column align='center' prop="created_user" label="创建人"></el-table-column>
        <el-table-column align='center' prop="publish_time" label="发布时间"></el-table-column>
        <el-table-column align='center' label="状态" width="240">
          <template slot-scope="scope">
            <span v-if="scope.row.read_status == 0" style="color: #ff1c1c;">未读</span>
            <span v-if="scope.row.read_status == 1" style="color: #0dcd2e;">已读</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center' width="300">
          <template slot-scope="scope">
            <el-button size="mini" type="primary"
              @click="$refs.detail.show(scope.row)">查看</el-button>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <detailDialog ref="detail" @read='getList()'></detailDialog>
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  import detailDialog from  './components/detailDialog.vue'
  import { publish_type, user_type } from  '@/filters'
  var that;
  export default {
    components: {
      detailDialog
    },
    props: {},
    data() {
      return {
        loading: true,
        query: {
          page_limit: 10,
          page: 1,
          total: 0
        },
        list: [],
      }
    },
    computed: {
     
    },
    watch: {},
    created() {
      that = this;
      this.getList()
    },
    methods: {
      getList() {
        this.loading = true
        // userInfoAPI.getNoticeList(this.query).then(res => {
        userInfoAPI.messageList(this.query).then(res => {
          if (res && res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .record1 {
    height: 20px;
  }

  .record3 {
    margin-left: 20px;
  }

  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
